<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="elevation-0 transparent">
	  		  <v-card-title primary-title>
	  		  	
	  		  	<v-btn 
	  		  		color="primary" 
	  		  		small 
	  		  		class="mr-2" 
	  		  		icon 
	  		  		@click="regresar()"
	  		  		v-if="carpetaSeleccionadas.length"
	  		  	>
	  		  		<v-icon>mdi-arrow-left-circle</v-icon>
	  		  	</v-btn>

	  		    <span class="text-h6 font-weight-bold copy-btn" >Carpetas</span>
	  		    <v-spacer></v-spacer>
	  		    <v-btn
              color="primary"
              dark
              class="mr-2"
              @click="agregarDialog()"
              small
              rounded
              v-if="['ADMIN','SUPERVISOR'].includes(permiso)"
            >
              <v-icon>mdi-folder-plus</v-icon>
            </v-btn>

            <v-btn
              color="orange"
              dark
              @click="agregarDialogArchivo()"
              small
              v-if="['ADMIN','SUPERVISOR'].includes(permiso)"
              rounded
            >
              <v-icon>mdi-file-plus</v-icon>
            </v-btn>
	  		  </v-card-title>

	  		  <v-card-text>
	  		  	<v-row class="flex">
	  		  		<v-col cols="12" v-if="!carpetas.length">
                <v-alert border="bottom" colored-border type="warning" elevation="2">
                  <v-card-title class="font-weight-bold subtitle-1">NO HAY CARPETAS DISPONIBLES</v-card-title>
                </v-alert>
				      </v-col>
            </v-row>

            <v-row>
	  		  		<v-col cols="3" sm="2" md="2" lg="1" v-for="(carpeta, i) in carpetas" :key="i" v-if="carpetas.length" >
				        <v-card 
                  class="transparent elevation-0" 
                  @dblclick="abrirSubcarpeta( carpeta )"
                  @contextmenu="clickDerecho($event, carpeta)"
                  @change="carpetaEditar = carpeta"
                >
                  <v-hover v-slot="{ hover }">
                    <v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }" class="transparent" >
                      <v-img
                        :src="require('@/assets/carpeta.png')"
                        class="my-3 transparent"
                        contain
                      />
                    </v-card>
                  </v-hover>

				          <v-card-actions class="pt-0">
				            <v-spacer></v-spacer>
				            {{ carpeta.carpeta }}
				            <v-spacer></v-spacer>
				          </v-card-actions>
				        </v-card>
				      </v-col>

              <v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute offset-y v-if="['ADMIN','SUPERVISOR'].includes(permiso)">
                <v-list >
                  <v-list-item 
                    v-for="(item, index) in items" :key="index" link
                    @click="item.accion == 'rename'? (modal_renombrar_carpeta = true,nombre_carpeta= carpetaEditar.carpeta):
                                                     (modal_eliminar_carpeta = true, nombre_carpeta= carpetaEditar.carpeta)"
                  >
                    <v-list-item-title>{{ item.title }} </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>


            <v-row>
              <v-col cols="12" md="6" lg="5" xl="4">
                <v-text-field
                  label="Búscar"
                  v-model="search"
                  outlined
                  dense
                  hide-details
                  rounded
                  append-icon="mdi-magnify"
                ></v-text-field>
              </v-col>
            </v-row>
            
            <v-row>
              <v-col
                v-for="(archivo, j) in filterArchivos"
                :key="j"
                cols="12"
                class="d-flex align-end py-2"
                @dblclick="abrir_documento(archivo)"
              >
                <v-hover v-slot="{ hover }">
               
                  <v-card 
                    :elevation="hover ? 8 : 0" 
                    :class="{ 'on-hover': hover }" 
                    width="100%"  
                    @contextmenu="clickDerechoDetalle($event, archivo)"
                  >
                    <v-list two-line class="py-0 pa-0">
                      <v-list-item >
                        <v-list-item-avatar>
                          <v-img
                            v-if="['BMP', 'GIF', 'jpg', 'jpeg', 'png', 'webp', 'svg'].includes( archivo.extension )"
                            :src="require('@/assets/imagen.png')"
                            class="my-3"
                            contain
                          />

                          <v-img
                            v-if="['pdf', 'PDF'].includes( archivo.extension )"
                            :src="require('@/assets/pdf.png')"
                            class="my-3"
                            contain
                          />

                          <v-img
                            v-if="['doc', 'docx'].includes( archivo.extension )"
                            :src="require('@/assets/word.png')"
                            class="my-3"
                            contain
                          />
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold"> {{ archivo.nombre + '.' + archivo.extension }}  </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-hover>
              </v-col>

              <v-menu v-model="showMenuDetalle" :position-x="z" :position-y="k" absolute offset-y>
                <v-card v-if="archivoAEditar" class="pa-4">
                  <v-card-text class="py-0"> <b>Archivo:         </b> {{ archivoAEditar.nombre}}.{{ archivoAEditar.extension }} </v-card-text>
                  <v-divider class="ma-2"></v-divider>

                  <v-card-text class="py-0"> <b>Creación:         </b> {{ archivoAEditar.fecha_creacion }}       </v-card-text>
                  <v-card-text class="py-0"> <b>Usuario creador:  </b> {{ archivoAEditar.creador }}              </v-card-text>
                  <v-divider class="ma-2"></v-divider>
                  <v-card-text class="py-0"> <b>Actualización:    </b> {{ archivoAEditar.fecha_actualizacion }}  </v-card-text>
                  <v-card-text class="py-0"> <b>Usuario modifico: </b> {{ archivoAEditar.modifico }}             </v-card-text>
                  <v-card-actions>
                    <v-btn color="error" @click="eliminarArchivo( archivoAEditar )">Eliminar <v-icon right>mdi-delete</v-icon></v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
	  		  	</v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>
    
    <AgregarCarpeta       
    	v-if="dialog.estatus == true"  
    	:dialog="dialog"
    	:carpetaSeleccionadas="carpetaSeleccionadas"
    	@cancelar="cancelar"
    	@initialize="initialize"
    	@recargarCarpeta="recargarCarpeta"
    />

    <AgregarArchivo       
      v-if="dialogArchivos.estatus == true"  
      :dialogArchivos="dialogArchivos"
      :carpetaSeleccionadas="carpetaSeleccionadas"
      @cancelar="cancelar"
      @initialize="initialize"
      @recargarCarpeta="recargarCarpeta"
      @agregarArchivoLista="agregarArchivoLista"
    />

    <!-- Renombrar carpeta -->
    <v-dialog v-model="modal_renombrar_carpeta" width="300" height="150">
      <v-card class="pa-3 ma-0">
        <v-card-text class="ma-0 pa-0"> Renombrar Carpeta</v-card-text>
        <v-text-field
          v-model="nombre_carpeta"
          outlined
          hide-details
          @keyup.enter="renombrar_carpeta()"
        ></v-text-field>
      </v-card>
    </v-dialog>

    <!-- Eliminar carpeta -->
    <v-dialog v-model="modal_eliminar_carpeta" width="350" height="150">
      <v-card class="pa-4">
        <v-card-text class="ma-0 pa-0 subtitle-1"> Estas seguro de querer eliminar la carpeta <b> {{ nombre_carpeta }} </b> ? </v-card-text> <br> <br>
        <v-footer absolute>
          <v-btn color="error" dark caption @click="modal_eliminar_carpeta = false" small> No, cancelar </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" dark text @click="eliminar_carpeta()" small> Si, eliminar </v-btn>
        </v-footer>
      </v-card>
    </v-dialog>

    <!-- Visualizador Archivo -->
    <v-dialog v-model="modal_archivos" width="80%" heigth="auto" v-if="archivo" >
      <v-hover v-slot="{ hover }">
        <v-card class="pa-1">
          <v-card-actions class="py-1">
            <v-spacer></v-spacer>
            <v-btn color="error" dark icon large @click="modal_archivos = false" >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-actions>

          <embed 
            v-if="archivo.extension == 'pdf'"
            :src="`https://support-smipack.com/viewer/web/viewer.html?file=https://support-smipack.com/archivos-mikai/`+archivo.archivo" 
            width="100%" 
            height="1000"
          >
         
          <v-img
            v-else-if="['jpg','jpeg','svg','webp','png','gif'].includes(archivo.extension)"
            :src="url + archivo.archivo"
            width="100%" 
            contain
            aspect-ratio="2"
          />
          
          <iframe 
            v-else
            :src="`https://view.officeapps.live.com/op/embed.aspx?wdPrint=0&zoom=0&src=https://support-smipack.com/archivos-mikai/`+archivo.archivo" 
            width="100%" 
            height="1000"
            frameborder='0'
            sandbox="allow-forms allow-modals allow-orientation-lock allow-popups allow-same-origin allow-scripts" 
            scrolling="no" 
            style="border: none; max-width: 100%; max-height: 100vh" 
            allowfullscreen 
            mozallowfullscreen 
            msallowfullscreen 
            webkitallowfullscreen
          >This is an embedded 
          </iframe>

          <v-expand-transition>
            <div
              v-if="hover"
              class="d-flex transition-fast-in-fast-out white v-card--reveal text-h2 white--text"
              style="height: 100%; width: 95%;"
            >
            </div>
          </v-expand-transition>

          <v-footer absolute class="white white--text">
            oijk
          </v-footer>

        </v-card>
      </v-hover>
    </v-dialog>

	</v-container>
</template>
<script>
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue'
  import AgregarCarpeta        from '@/components/archivos/AgregarCarpeta.vue'
  import AgregarArchivo        from '@/components/archivos/AgregarArchivo.vue'

  import validarErrores  from '@/mixins/validarErrores'

  export default {
  	components:{
      Alerta,
      carga,
      AgregarCarpeta,
      AgregarArchivo
    },

    mixins: [ validarErrores ],

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,
      carpetas:[],
			archivos:[],
			carpetaSeleccionadas: [],
			dialog:{
				estatus: false
			},

			dialogArchivos:{
				estatus: false
			},
      search:'',


      carpetaEditar: {},
      modal_renombrar_carpeta: false,
      nombre_carpeta:'',
      modal_eliminar_carpeta:false,
      showMenu: false,
      x: 0,
      y: 0,
      items: [
        { title: 'Renombrar carpeta', accion: 'rename' },
        { title: 'Eliminar carpeta' , accion: 'delete' },
      ],
      modal_archivos: false,
     
     verArchivo: 'https://support-smipack.com/pdf/DM210649_C_ES.pdf',
      //verArchivo: 'C:/viewer/web/ingresos.pdf'
      archivo: null,
      url:'',

      showMenuDetalle: false,
      k:0,
      z:0,
      archivoAEditar: null,

      permiso: null,
    }),

    computed: {
      ...mapGetters('login', ['getdatosUsuario']),

      formTitle () {
        return this.editedIndex === -1 ? 'Agregar Forma de pago' : 'Editar forma de pago'
      },

      filterArchivos( ){
        if( this.search ){
          return this.archivos.filter( el => {
            let nombreArchivo = el.nombre + '.' + el.extension
            let datos_completos = nombreArchivo.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"")
            const buscar        = this.search.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"")
            return datos_completos.match(buscar);
            // return datos_completos.match(buscar) && el.unidad_negocio == this.getEscuela;
          })
        }else{
          return this.archivos
        }
      }

    },

    async created () {
      this.permiso = this.getdatosUsuario.admin
      await this.initialize();
      this.url = this.$http.options.root + 'archivos.mikai/'
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.carpetas = []
        this.archivos = []
        return this.$http.get('carpetas.principales/' + this.getdatosUsuario.id).then(response=>{
        	this.carpetaSeleccionadas = []
        	this.carpetas = response.body.carpetas
        	this.archivos = response.body.archivos
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      abrirSubcarpeta( item ){
      	this.cargar = true
      	this.carpetaSeleccionadas.push( item )
        this.carpetas = []
        this.archivos = []
        item.nivel = item.nivel + 1 
        return this.$http.post('carpetas.get.nivel', item ).then(response=>{
        	this.carpetas = response.body.carpetas
        	this.archivos = response.body.archivos
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      recargarCarpeta( item ){
      	this.carpetas.push( item )
      },

      regresar( ){
      	// si el nivel == 1 entonces hay que consultar las carpetas raíz
      	if( this.carpetaSeleccionadas.length == 1 ){
      		this.initialize( )
      	}else{
      		this.getCarpetaAtras( )
      	}
      },

      getCarpetaAtras( ){
      	this.cargar = true
      	const ultimaCarpeta = this.carpetaSeleccionadas[ this.carpetaSeleccionadas.length - 1 ]
        this.carpetas = []
        this.archivos = []
        return this.$http.post('carpetas.exacta', ultimaCarpeta ).then(response=>{
        	this.carpetaSeleccionadas.pop()
        	this.carpetas = response.body.carpetas
        	this.archivos = response.body.archivos
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      agregarDialog( ){
      	this.dialog.estatus = true
      	console.log( this.carpetaSeleccionadas )
      },

      cancelar( ){
      	this.dialog.estatus = false
      },

      agregarDialogArchivo( ){
      	this.dialogArchivos.estatus = true
      },

      agregarArchivoLista( item ){
        this.archivos.push( item )
      },

      eliminarArchivo( archivo ){
        this.$http.delete('eliminar.archivo/'+ archivo.idarchivos).then( response =>{
          this.initialize();
        }).catch(error =>{
          console.log('ocurrio un error', error)
        }).finally(()=> { this.modal_eliminar_carpeta = false})
      },

      renombrar_carpeta(){
        const payload ={ 
          id_carpeta: this.carpetaEditar.idcarpetas,
          nombre_carpeta: this.nombre_carpeta,
        }
        this.$http.post('renombrar.carpeta', payload).then( response =>{
          this.initialize();
        }).catch(error =>{
          console.log('ocurrio un error', error)
        }).finally(()=> { this.modal_renombrar_carpeta = false})
      },

      eliminar_carpeta(){
        this.$http.delete('eliminar.carpeta/'+ this.carpetaEditar.idcarpetas).then( response =>{
          this.initialize();
        }).catch(error =>{
          console.log('ocurrio un error', error)
        }).finally(()=> { this.modal_eliminar_carpeta = false})
      },

      clickDerecho(e, itemAEditar){
        this.carpetaEditar = itemAEditar;
        e.preventDefault()
        this.showMenu = false;
        this.showMenuDetalle = false;

        this.x = e.clientX
        this.y = e.clientY
        this.$nextTick(() => {
          this.showMenu = true
        })
      },

      abrir_documento(archivo){
        this.archivo = archivo;
        this.verArchivo = this.url + archivo.archivo
        console.log( this.verArchivo )
        // this.verArchivo = 'https://sofsolution.club/words/curriculum_Eduardo.docx'
       // this.verArchivo = 'https://support-smipack.com/pdf/DM210649_C_ES.pdf'
        this.modal_archivos = true
      },

      clickDerechoDetalle(e, itemAEditar){
        this.archivoAEditar = itemAEditar;
        e.preventDefault()
        this.showMenuDetalle = false;
        this.showMenu = false;
        this.z = e.clientX
        this.k = e.clientY
        this.$nextTick(() => {
          this.showMenuDetalle = true
        })
      },
    },
  }
</script>
<style scoped>
  .textFormat{
    float: right;
    display: flex;
    align-items: center;
    word-break:break-all;
    margin: 0 0 1em 1em;
  }
 
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .1;
    position: absolute;
    width: 100%;
  }
</style>